export default __webpack_public_path__ + "static/media/C1_Logo_Blue_RGB.7b931860.png";